import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { listClientes } from '@/api/clientes';
import { Header } from '@/components/Header';
import { Card } from '@/components/Card';
import { StatusTag } from '@/components/StatusTag';
import styles from './pages.module.css';

export function HomePage() {
  const navigate = useNavigate();
  const { data, isLoading, error } = useQuery({
    queryKey: ['clientes'],
    queryFn: listClientes,
  });

  return (
    <>
      <Header
        breadcrumbs={[{ label: 'Inicio' }]}
        title="Implementaciones · Estado por Cliente"
        subtitle="Selecciona un cliente para ver sus instalaciones y el avance de cada propuesta adjudicada."
        meta={
          <>
            <span>{data?.length ?? '—'} clientes</span>
            <span>
              {data?.reduce((acc, c) => acc + (c.facilities?.length || 0), 0) ?? '—'} instalaciones
            </span>
          </>
        }
      />

      <div className={`container ${styles.body}`}>
        {isLoading && <div className="empty">Cargando…</div>}
        {error && <div className="empty">No se pudieron cargar los clientes.</div>}

        {data && (
          <div className={styles.grid}>
            {data.map((c) => {
              const totalFac = c.facilities?.length || 0;
              const activas = c.facilities?.filter((f) => f.status === 'activa').length || 0;
              return (
                <Card
                  key={c.id}
                  bannerColor={c.color}
                  icon={c.iniciales || c.nombre.charAt(0)}
                  title={c.nombre}
                  subtitle={c.industria || undefined}
                  stats={[
                    { num: totalFac, label: 'Instalaciones' },
                    { num: activas, label: 'Activas' },
                    { num: totalFac - activas, label: 'Pendientes' },
                  ]}
                  progressBars={c.progress}
                  health={c.progress?.health}
                  footer={
                    <>
                      <StatusTag status={activas > 0 ? 'activa' : 'pendiente'}>
                        {activas > 0 ? 'En implementación' : 'Por configurar'}
                      </StatusTag>
                      <span className={styles.arrow}>Ver instalaciones →</span>
                    </>
                  }
                  actions={
                    <>
                      <button
                        onClick={() =>
                          navigate(`/clientes/${c.slug}/compromisos`)
                        }
                        style={{
                          flex: 1,
                          padding: '7px 10px',
                          borderRadius: 8,
                          border: '1px solid var(--border)',
                          background: 'var(--surface-2)',
                          color: 'var(--text)',
                          fontSize: 12,
                          fontWeight: 600,
                          cursor: 'pointer',
                        }}
                      >
                        📋 Pendientes
                      </button>
                      <button
                        onClick={() =>
                          navigate(`/clientes/${c.slug}/compromisos?estado=bloqueados`)
                        }
                        style={{
                          flex: 1,
                          padding: '7px 10px',
                          borderRadius: 8,
                          border: '1px solid #fca5a5',
                          background: '#fef2f2',
                          color: '#b91c1c',
                          fontSize: 12,
                          fontWeight: 700,
                          cursor: 'pointer',
                        }}
                      >
                        🚫 Bloqueados
                      </button>
                    </>
                  }
                  onClick={() => navigate(`/clientes/${c.slug}`)}
                />
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}
